const env = {
  MODE: import.meta.env.MODE,
  API_LOGIN_PATH: import.meta.env.VITE_LOGIN_PATH || 'auth/signin',
  API_REFRESH_PATH: import.meta.env.VITE_LOGIN_PATH || 'auth/refresh',
  RECAPTCHA_PUBLIC_KEY: import.meta.env.VITE_RECAPTCHA_PUBLIC_KEY,
  APICOMUNI_URL: import.meta.env.VITE_APICOMUNI_URL,
  APICOMUNI_API_KEY: import.meta.env.VITE_APICOMUNI_API_KEY!,
  DOCUMENTS_URL: import.meta.env.VITE_DOCUMENTS_URL,
};

export default env;
